export interface SearchResult {
    type: SearchResultType
    ref_id: string
    service_id?: string
    customer_id?: string
    company_name?: string
    entity_name?: string
    email?: string
    industry?: string
    services?: string
    details?: string
    service_name?: string
    contract_id?: number
    contract_number_id?: string
    invoice_code?: string
    account_manager?: string
    activated_at?: string
    created_at: string
    customer_status?: CustomerStatus
    service_status?: ServiceStatus
    invoice_status?: InvoiceStatus
    contract_status?: ContractStatus
}

export type SearchResultType = 'customer' | 'service' | 'invoice' | 'contract'

export type CustomerStatus =
    | 'trial'
    | 'cool-lead'
    | 'qualified-prospect'
    | 'stopped'
    | 'active'
    | 'dead-lead'

export const CUSTOMER_STATUS_CONFIG: Record<
    CustomerStatus,
    { label: string; color: string }
> = {
    trial: { label: 'customer-trial', color: 'warning' },
    'cool-lead': { label: 'cool-lead', color: 'default' },
    'qualified-prospect': { label: 'qualified-prospect', color: 'primary' },
    stopped: { label: 'stopped', color: 'error' },
    active: { label: 'customer-active', color: 'success' },
    'dead-lead': { label: 'dead-lead', color: 'error' },
}

export type ServiceStatus =
    | 'waiting-confirm'
    | 'active'
    | 'cancelled'
    | 'trialing'
    | 'rejected'
    | 'on-resubmit-information'
    | 'waiting-create-service'
    | 'pending-terminated'

export const SERVICE_STATUS_CONFIG: Record<
    ServiceStatus,
    { label: string; color: string }
> = {
    'waiting-confirm': { label: 'waiting-confirm', color: 'primary' },
    active: { label: 'active', color: 'success' },
    cancelled: { label: 'cancelled', color: 'error' },
    trialing: { label: 'trialing', color: 'warning' },
    rejected: { label: 'rejected', color: 'error' },
    'on-resubmit-information': {
        label: 'on-resubmit-information',
        color: 'warning',
    },
    'waiting-create-service': {
        label: 'waiting-create-service',
        color: 'warning',
    },
    'pending-terminated': {
        label: 'pending-terminated',
        color: 'warning',
    },
}

export type InvoiceStatus = 'paid' | 'unpaid' | 'overdue' | 'cancelled'

export const INVOICE_STATUS_CONFIG: Record<
    InvoiceStatus,
    { label: string; color: string }
> = {
    paid: { label: 'paid', color: 'success' },
    unpaid: { label: 'unpaid', color: 'warning' },
    overdue: { label: 'overdue', color: 'error' },
    cancelled: { label: 'cancelled', color: 'error' },
}

export type ContractStatus = 'pending' | 'exchanging' | 'uploading' | 'active'

export const CONTRACT_STATUS_CONFIG: Record<
    ContractStatus,
    { label: string; color: string }
> = {
    pending: { label: 'pending', color: 'warning' },
    exchanging: { label: 'exchanging', color: 'primary' },
    uploading: { label: 'uploading', color: 'default' },
    active: { label: 'active', color: 'success' },
}

export interface SearchParams {
    query: string
    scopes?: SearchResultType[]
    account_manager?: string
    status?: string
    created_from?: string
    created_to?: string
    limit?: number
    offset?: number
}

export interface SearchResponse {
    results: SearchResult[]
    total: number
    has_more: boolean
}

export interface SearchSuggestion {
    text: string
    type: SearchResultType
    count: number
}

export interface SearchFilters {
    types: SearchResultType[]
    statuses: string[]
    account_managers: string[]
    date_range: {
        from: string | null
        to: string | null
    }
}

export interface SearchResultWrapLine {
    label: string
    subtitle?: string
    redirect_to?: string
    created_at: string
    status?: {
        label: string
        color: string
    }
    icon?: React.ReactNode
    email?: string
}
